document.addEventListener('DOMContentLoaded', function() {
  const mq = window.matchMedia("(min-width: 768px)");

  // Track the user's chosen view so it persists across filter updates
  let userSelectedView = null;

  function initViewToggle() {
    const wrapper = document.querySelector('.collection-grid__wrapper');
    const gridContainer = document.querySelector('.collection-grid__wrapper .grid.grid--uniform');
    const toggleButtons = document.querySelectorAll('.toggle-view');
    const pageType = wrapper ? wrapper.dataset.pageType : null;

    if (!gridContainer) return;

    // If user previously selected a view, apply it (overrides server default)
    if (userSelectedView) {
      gridContainer.classList.remove('mode-grid', 'mode-list');
      gridContainer.classList.add(`mode-${userSelectedView}`);
    }

    // Check if already has mode-grid or mode-list
    let currentMode = [...gridContainer.classList].find(c => c.startsWith("mode-"));

    // If no mode set yet, assign default
    if (!currentMode) {
      let defaultView = pageType === "search" ? "grid" : "list";
      gridContainer.classList.add(`mode-${defaultView}`);
      currentMode = `mode-${defaultView}`;
    }

    // Update toggle UI
    const activeView = currentMode.replace("mode-", "");
    toggleButtons.forEach(btn => {
      btn.classList.toggle("active-toggle", btn.dataset.view === activeView);
    });

    // Add click events
    toggleButtons.forEach(button => {
      button.addEventListener('click', function() {
        const view = this.dataset.view;
        userSelectedView = view;

        // Re-query in case DOM was replaced
        const gc = document.querySelector('.collection-grid__wrapper .grid.grid--uniform');
        const btns = document.querySelectorAll('.toggle-view');
        if (!gc) return;

        gc.classList.remove('mode-grid', 'mode-list');
        gc.classList.add(`mode-${view}`);

        btns.forEach(btn => btn.classList.remove('active-toggle'));
        this.classList.add('active-toggle');
      });
    });
  }

  initViewToggle();
  mq.addEventListener("change", initViewToggle);

  // Re-initialize after AJAX filter updates replace the DOM
  document.addEventListener('on:facet-filters:updated', initViewToggle);
  document.addEventListener('collection:reloaded', initViewToggle);
});

function scrollToGroup(id) {
  var target = document.querySelector('#group-div-' + id);
  if (!target) return;

  var header = document.querySelector('.site-header');
  var headerOffset = (header ? header.offsetHeight : 0) + 20;
  var elementPosition = target.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({
    top: elementPosition - headerOffset,
    behavior: 'smooth'
  });
}


/* Breadcrumb scroll affordance: flag overflowing breadcrumbs so the
   right-edge fade hint (see custom.css) only shows when there's more
   to swipe, and remove it once the user has scrolled to the end. */
(function () {
  function syncBreadcrumb(scroller) {
    if (!scroller) return;
    var overflowing = scroller.scrollWidth > scroller.clientWidth + 2;
    var atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
    var nav = scroller.closest('nav') || scroller;
    nav.classList.toggle('breadcrumb--overflow', overflowing && !atEnd);
  }
  function initBreadcrumbs() {
    var scrollers = document.querySelectorAll('.breadcrumb-list');
    scrollers.forEach(function (el) {
      syncBreadcrumb(el);
      el.addEventListener('scroll', function () { syncBreadcrumb(el); }, { passive: true });
    });
    window.addEventListener('resize', function () {
      scrollers.forEach(syncBreadcrumb);
    }, { passive: true });
  }
  if (document.readyState !== 'loading') initBreadcrumbs();
  else document.addEventListener('DOMContentLoaded', initBreadcrumbs);
  /* Re-check shortly after load: breadcrumb JS resolves the path async */
  window.addEventListener('load', function () { setTimeout(initBreadcrumbs, 400); });
})();

/* ============================================================
   Product identifiers -> ALL CAPS inside free-text content
   (specifications, product details, description, bullets).
   Discrete "Item#:" / "SKU:" outputs are upcased in Liquid;
   this handles identifiers embedded in admin-entered HTML.
   Conservative by design:
     - only runs on product pages
     - only acts on values that follow a recognized label
       (Item / SKU / Part / Vendor Part / Mfr Part / MPN / Model)
     - the value must look like a code (contains a digit), so
       normal prose is never uppercased.
   ============================================================ */
(function () {
  var body = document.body;
  if (!body || body.className.indexOf('template-product') === -1) return;

  // A cell/element whose entire text is just an identifier label.
  var LABEL = /^\s*(?:item|sku|part|vendor\s*part|mfr\.?\s*part|manufacturer\s*part|mpn|model)\s*(?:#|no\.?|number|num)?\.?\s*[:#]?\s*$/i;
  // Inline "Label: value" within a single text node.
  var INLINE = /((?:item|sku|part|vendor\s*part|mfr\.?\s*part|manufacturer\s*part|mpn|model)\s*(?:#|no\.?|number|num)?\.?\s*[:#]\s*)([A-Za-z0-9][\w.\/-]*)/gi;
  var isCode = function (v) { return /\d/.test(v) && /^[A-Za-z0-9][\w.\/-]*$/.test(String(v).trim()); };

  function upcaseValueEl(el) {
    if (!el) return;
    if (el.children.length === 0) { el.textContent = el.textContent.toUpperCase(); return; }
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), x;
    while ((x = w.nextNode())) { x.nodeValue = x.nodeValue.toUpperCase(); }
  }

  function run(scope) {
    // 1) Table rows: "Label | Value"
    scope.querySelectorAll('tr').forEach(function (tr) {
      var cells = tr.children;
      if (cells.length >= 2 && LABEL.test(cells[0].textContent || '')) {
        upcaseValueEl(cells[cells.length - 1]);
      }
    });
    // 2) Definition lists: <dt>Label</dt><dd>Value</dd>
    scope.querySelectorAll('dt').forEach(function (dt) {
      if (LABEL.test(dt.textContent || '')) upcaseValueEl(dt.nextElementSibling);
    });
    // 3) <strong>/<b>/<th> label followed by a value node/element
    scope.querySelectorAll('strong, b, th').forEach(function (lab) {
      if (!LABEL.test(lab.textContent || '')) return;
      var sib = lab.nextSibling;
      if (sib && sib.nodeType === 3 && isCode(sib.nodeValue)) {
        sib.nodeValue = sib.nodeValue.toUpperCase();
      } else if (lab.nextElementSibling) {
        upcaseValueEl(lab.nextElementSibling);
      }
    });
    // 4) Inline "Label: value" inside one text node (e.g. <p>Item #: abc123</p>)
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (node) {
      var t = node.nodeValue;
      INLINE.lastIndex = 0;
      var changed = t.replace(INLINE, function (m, label, val) {
        return isCode(val) ? label + val.toUpperCase() : m;
      });
      if (changed !== t) node.nodeValue = changed;
    });
  }

  function init() {
    document.querySelectorAll(
      '.info-block, .tabs-accordion__panel-inner, .bullet-point-sec'
    ).forEach(function (scope) {
      // Exclude the entire Resources tab.
      if (scope.id === 'tab-resources' || scope.closest('#tab-resources, .resources-content')) return;
      run(scope);
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
